export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8636.3c3ead22.jpg";